import React from 'react';
import { Users, Eye, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { formatCurrency } from './constants';

const CommissionsSummaryTable = ({
  loading,
  filteredSummary,
  totals,
  onViewDetail,
  onMarkAsPaid
}) => {
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-4">
        <CardTitle className="text-lg flex items-center gap-2">
          <Users className="w-5 h-5 text-[#1a5192]" />
          Resumen por Médico Referente
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="w-8 h-8 border-4 border-[#1a5192]/30 border-t-[#1a5192] rounded-full animate-spin" />
          </div>
        ) : filteredSummary.length === 0 ? (
          <div className="text-center py-12 text-slate-500">
            <AlertCircle className="w-12 h-12 mx-auto mb-3 text-slate-300" />
            <p>No hay comisiones en el período seleccionado</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50">
                  <TableHead className="font-semibold">Médico Referente</TableHead>
                  <TableHead className="text-center font-semibold">Referencias</TableHead>
                  <TableHead className="text-right font-semibold">Total Facturado</TableHead>
                  <TableHead className="text-right font-semibold">Comisión 13%</TableHead>
                  <TableHead className="font-semibold">Datos Bancarios</TableHead>
                  <TableHead className="text-center font-semibold">Estado</TableHead>
                  <TableHead className="text-center font-semibold">Acciones</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredSummary.map((doctor, idx) => (
                  <TableRow key={idx} className="hover:bg-slate-50">
                    <TableCell className="font-medium">{doctor.medico_referente}</TableCell>
                    <TableCell className="text-center">{doctor.cantidad_pacientes}</TableCell>
                    <TableCell className="text-right">{formatCurrency(doctor.total_facturado)}</TableCell>
                    <TableCell className="text-right font-semibold text-emerald-600">
                      {formatCurrency(doctor.comision)}
                    </TableCell>
                    <TableCell>
                      {doctor.banco ? (
                        <div className="text-sm">
                          <p className="font-medium text-slate-800">{doctor.banco}</p>
                          <p className="text-slate-500 font-mono text-xs">{doctor.numero_cuenta}</p>
                          {doctor.tipo_cuenta && (
                            <Badge variant="outline" className="text-xs mt-1 border-slate-300">{doctor.tipo_cuenta}</Badge>
                          )}
                        </div>
                      ) : (
                        <span className="text-slate-400 text-sm">No registrado</span>
                      )}
                    </TableCell>
                    <TableCell className="text-center">
                      {doctor.pagado ? (
                        <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">
                          <CheckCircle className="w-3 h-3 mr-1" />
                          Pagado
                        </Badge>
                      ) : (
                        <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100">
                          <Clock className="w-3 h-3 mr-1" />
                          Pendiente
                        </Badge>
                      )}
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center justify-center gap-2">
                        <Button
                          size="sm"
                          variant="ghost"
                          onClick={() => onViewDetail(doctor)}
                          className="text-[#1a5192] hover:text-[#0d3a6e] hover:bg-[#1a5192]/10"
                          title="Ver detalle"
                        >
                          <Eye className="w-4 h-4" />
                        </Button>
                        {!doctor.pagado && (
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => onMarkAsPaid(doctor)}
                            className="text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50"
                            title="Marcar como pagado"
                          >
                            <CheckCircle className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
                {/* Totals row */}
                <TableRow className="bg-slate-100 font-bold">
                  <TableCell>TOTALES</TableCell>
                  <TableCell className="text-center">{totals.total_pacientes}</TableCell>
                  <TableCell className="text-right">{formatCurrency(totals.total_facturado)}</TableCell>
                  <TableCell className="text-right text-emerald-600">{formatCurrency(totals.total_comision)}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CommissionsSummaryTable;
